export default {
  app: {
    tradeOffers: {
      country: 'Land',
      loginPrompt: 'Um private B2B-Angebote zu sehen, müssen Sie {0}.',
      logIn: 'sich anmelden',
    },
  },
};
